import { CALCULATION_FREQUENCIES } from '../utils/constants';

/**
 * Return a value from the CALCULATION_FREQUENCIES that matches the given
 * frequency.
 * The value returned is defaulted as the label, however, it can be anything
 * from the CALCULATION_FREQUENCIES keys.
 */
export default (frequency, key = 'label') => {
  if (!frequency || !CALCULATION_FREQUENCIES[frequency]) {
    return undefined;
  }
  return CALCULATION_FREQUENCIES[frequency][key];
};
